import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ChartHeader from '@/modules/Statistics/components/ChartHeader.vue';
import { formatValueForDashboard } from '@/helpers/NumberFormatter';

interface Props {
    data: any;
    isEdit: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TotalReport',
  props: {
    data: null,
    isEdit: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    data: any;
    isEdit: boolean;
};



const reportSize = computed(() => {
    switch (props.data.size) {
        case 'S':
            return {
                width: '48%',
            };
        default:
            return {
                width: '100%',
            };
    }
});

function fontSize(element: string) {
    switch (props.data.size) {
        case 'S':
            return `total-report__${element}--font-small`;
        case 'L':
            return `total-report__${element}--font-large`;
        default:
            return '';
    }
}

function changeChartSize(size: 'S' | 'M' | 'L') {
    props.data.size = size;
}

return { __sfc: true,props, reportSize, fontSize, changeChartSize, ChartHeader, formatValueForDashboard }
}

})